export default __webpack_public_path__ + "static/media/verifyCode.e013b56c.svg";